/**
 * Available languages in the application
 */
export const AVAILABLE_LANGUAGES = ['fr', 'it', 'de'] as const;
export type SupportedLanguage = (typeof AVAILABLE_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: SupportedLanguage = 'de';

/**
 * Get the browser language code.
 * If the browser language is not supported, it falls back to DEFAULT_LANGUAGE.
 *
 * @returns {SupportedLanguage} The browser language code ('fr', 'it', or 'de')
 */
export function getBrowserLanguageCode(): SupportedLanguage {
    const browserLanguage = navigator.language.slice(0, 2);
    return AVAILABLE_LANGUAGES.includes(browserLanguage as SupportedLanguage) ? (browserLanguage as SupportedLanguage) : DEFAULT_LANGUAGE;
}

/**
 * Validates if the given language code is supported
 */
export function isValidLanguage(lang: string | null): lang is SupportedLanguage {
    return !!lang && AVAILABLE_LANGUAGES.includes(lang as SupportedLanguage);
}
